import { NotifierTypeEnum } from "./notifier-type.enum";

export class NotifierModel {
    type:NotifierTypeEnum;
    data:any;
    constructor(type:NotifierTypeEnum,data:any) {
        this.type = type;
        this.data = data;
    }
}